import countryList from 'react-select-country-list';

// Niveaux qui ne nécessitent pas de domaine de formation
export const NIVEAUX_SANS_DOMAINE = ['primaire', 'secondaire 1er cycle', 'secondaire 2ème cycle', 'secondaire 2eme cycle'];

// État initial du formulaire
export const EMPTY_FORM_DATA = {
    diplome: '',
    date_obtention: '',
    etablissement: '',
    niveau_etude: '',
    pays: 'Niger',
    domaine_formation: ''
};

// Options de pays
export const getCountries = () => countryList().getData();
export const getNigerOption = (countries) => countries.find(country => country.value === 'NE') || { value: 'NE', label: 'Niger' };
